// extracted by mini-css-extract-plugin
module.exports = {"btnClear":"InputClear_btnClear__Lj-QX","linkAdd":"InputClear_linkAdd__15mg9"};